// confirmationStore.ts
import { createZustandContext } from '@/lib/zustand';
import { createStore, useStore } from 'zustand';

interface ConfirmationState {
  open: boolean;
  title: string | null;
  description: string | null;
  cancelLabel: string | null;
  actionLabel: string | null;
  actionButtonVariant: 'default' | 'destructive' | 'outline' | 'ghost' | null;
  onAction: () => void;
  onCancel: () => void;
}

interface ConfirmationActions {
  openConfirmation: (data: {
    title: string;
    description: string;
    cancelLabel: string;
    actionLabel: string;
    actionButtonVariant?:
      | 'default'
      | 'destructive'
      | 'outline'
      | 'ghost'
      | null;
    onAction: () => void;
    onCancel: () => void;
  }) => void;
  closeConfirmation: () => void;
}

const ConfirmationStore = createZustandContext(() => {
  return createStore<ConfirmationState & ConfirmationActions>((set) => ({
    open: false,
    title: null,
    description: null,
    cancelLabel: null,
    actionLabel: null,
    actionButtonVariant: null,
    onAction: () => {},
    onCancel: () => {},
    openConfirmation: (data) =>
      set(() => ({
        open: true,
        title: data.title,
        description: data.description,
        cancelLabel: data.cancelLabel,
        actionLabel: data.actionLabel,
        onAction: data.onAction,
        onCancel: data.onCancel,
        actionButtonVariant: data.actionButtonVariant,
      })),
    closeConfirmation: () => {
      set(() => ({
        open: false,
      }));

      setTimeout(() => {
        set(() => ({
          title: null,
          description: null,
          cancelLabel: null,
          actionLabel: null,
          onAction: () => {},
          onCancel: () => {},
          actionButtonVariant: null,
        }));
      }, 300);
    },
  }));
});

export const useConfirmationStore = <T,>(
  selector: (state: ConfirmationState & ConfirmationActions) => T,
) => useStore(ConfirmationStore.useContext(), selector);

export default ConfirmationStore;
